
import { defineComponent } from 'vue'
import { mapActions, mapGetters } from 'vuex'

import ControlPanelBaseMixin from '~/mixins/control-panel/ControlPanelBaseMixin'
import { OrgGroupsActions, OrgGroupsGetters } from '~/store/control-panel/groups'
import { EnterpriseGroup } from '~/types/types'

export default defineComponent({
  name: 'ControlPanelInvite',
  mixins: [ControlPanelBaseMixin],
  props: {
    groupId: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      selectedGroup: '',
      inviteLink: '',
      resettingLink: false,
      isLoading: true
    }
  },

  async fetch(): Promise<void> {
    await this.fetchGroupInvites({ refetch: true })
    if (this.groupInvites.length) {
      if (this.groupId) {
        this.triggerChange(this.groupId)
      } else if (this.selectedGroup) {
        this.triggerChange(this.selectedGroup)
      } else if (this.$route.query['group']) {
        this.selectedGroup = this.$route.query['group'].toString()
      } else {
        this.selectedGroup = this.groupInvites[0].id
      }
    }
    this.resettingLink = false
    this.isLoading = false
  },

  computed: {
    ...mapGetters('control-panel/groups', {
      groupInvites: OrgGroupsGetters.ORG_GROUP_INVITES_DATA
    })
  },

  methods: {
    ...mapActions('control-panel/groups', {
      fetchGroupInvites: OrgGroupsActions.FETCH_GROUP_INVITES,
      resetGroupInvite: OrgGroupsActions.RESET_GROUP_INVITE
    }),

    triggerChange(value: string): void {
      this.inviteLink =
        this.groupInvites.find((groupInvite: EnterpriseGroup) => groupInvite.id === value)
          ?.invitationUrl || ''
    },

    async resetLink(): Promise<void> {
      this.resettingLink = true
      const response = await this.resetGroupInvite({ groupId: this.groupId || this.selectedGroup })
      if (response) this.$toast.success('Invite link reset succesfully.')
      else this.$toast.danger('An error occured while resetting invite link, please try again.')
      this.$fetch()
    }
  }
})
